import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1105OutputModel } from '../kymw1100/vo/kymw1105-output.model';
import { KYMW1105Component } from './kymw1105.component';

/**
 * eBASEデータ画面の値を管理するクラス
 *
 * @export KYMW1105Model
 * @class KYMW1105Model
 */
export class KYMW1105Model {

  kymw1105Component: KYMW1105Component;

  public pCode: string = <string>'';                                            // Pコード
  public itemCode: string = <string>'';                                         // アイテムコード
  public admitStatus: string = <string>'';                                      // 承認状態(0:eBASE取込後、1:仮登録、2:本登録)
  // 商品形態タブ
  public pieceSizeLength: string = <string>'';                                  // ピースサイズ(縦)
  public pieceSizeWidth: string = <string>'';                                   // ピースサイズ(横)
  public pieceSizeHeight: string = <string>'';                                  // ピースサイズ(高)
  public pieceWeight: string = <string>'';                                      // ピース重量
  public pieceContainNum: string = <string>'';                                  // ピース入数
  public packSizeLength: string = <string>'';                                   // パックサイズ(縦)
  public packSizeWidth: string = <string>'';                                    // パックサイズ(横)
  public packSizeHeight: string = <string>'';                                   // パックサイズ(高)
  public packWeight: string = <string>'';                                       // パック重量
  public packContainNum: string = <string>'';                                   // パック入数
  public bowlSizeLength: string = <string>'';                                   // ボールサイズ(縦)
  public bowlSizeWidth: string = <string>'';                                    // ボールサイズ(横)
  public bowlSizeHeight: string = <string>'';                                   // ボールサイズ(高)
  public bowlWeight: string = <string>'';                                       // ボール重量
  public bowlContainNum: string = <string>'';                                   // ボール入数
  public caseSizeLength: string = <string>'';                                   // ケースサイズ(縦)
  public caseSizeWidth: string = <string>'';                                    // ケースサイズ(横)
  public caseSizeHeight: string = <string>'';                                   // ケースサイズ(高)
  public caseWeight: string = <string>'';                                       // ケース重量
  public caseContainNum: string = <string>'';                                   // ケース入数
  // JANコードタブ
  public grp_janCode: string = <string>'';
  public pieceJanCode: string = <string>'';                                     // ピースＪＡＮコード
  public caseJanCode: string = <string>'';                                      // ケースＪＡＮコード
  public packJanCode: string = <string>'';                                      // パックＪＡＮコード
  public bowlJanCode: string = <string>'';                                      // ボールＪＡＮコード
  // 工場住所タブ
  public factoryAddress: string = <string>'';                                   // 工場住所
  public factoryAddressCount: number = <number>0;                               // 工場住所設定カウンタ

  // ラジオボタンバインド用変数
  public grpForm: string = <string>'';
  public grpJanCode: string = <string>'';


  /**
   * eBASEデータ 出力用VO取得
   *
   * @returns {KYMW1105OutputModel}
   * @memberof KYMW1105Model
   */
  public getKYMW1105OutputVo(): KYMW1105OutputModel {
    // 変数定義
    const vo: KYMW1105OutputModel = new KYMW1105OutputModel;                    // eBASEデータ 出力用VO

    // eBASEデータ 出力用VOを返却
    return vo;
  }

  /**
   * 商品仕様書マスタ情報設定
   *
   * @param {*} data
   * @memberof KYMW1105Model
   */
  public setGoodsSpecifcationInfo(data: any): void {
    let enabledCheckResult: boolean;                                            // 活性判定結果

    // 取得データを設定
    this.pCode = data.PCode;                                                 // Pコード
    this.itemCode = data.ItemCode;                                           // アイテムコード
    this.admitStatus = data.AdmitStatus;                                     // 承認状態
    this.pieceSizeLength = data.PieceSizeLength;                             // ピースサイズ（縦）
    this.pieceSizeWidth = data.PieceSizeWidth;                               // ピースサイズ（横）
    this.pieceSizeHeight = data.PieceSizeHeight;                             // ピースサイズ（高）
    this.pieceWeight = data.PieceWeight;                                     // ピース重量
    this.pieceContainNum = data.PieceContainNum;                             // ピース入数
    this.pieceJanCode = data.PieceJanCode;                                   // ピースＪＡＮコード
    this.packSizeLength = data.PackSizeLength;                               // パックサイズ（縦）
    this.packSizeWidth = data.PackSizeWidth;                                 // パックサイズ（横）
    this.packSizeHeight = data.PackSizeHeight;                               // パックサイズ（高）
    this.packWeight = data.PackWeight;                                       // パック重量
    this.packContainNum = data.PackContainNum;                               // パック入数
    this.packJanCode = data.PackJanCode;                                     // パックＪＡＮコード
    this.bowlSizeLength = data.BowlSizeLength;                               // ボールサイズ（縦）
    this.bowlSizeWidth = data.BowlSizeWidth;                                 // ボールサイズ（横）
    this.bowlSizeHeight = data.BowlSizeHeight;                               // ボールサイズ（高）
    this.bowlWeight = data.BowlWeight;                                       // ボール重量
    this.bowlContainNum = data.BowlContainNum;                               // ボール入数
    this.bowlJanCode = data.BowlJanCode;                                     // ボールＪＡＮコード
    this.caseSizeLength = data.CaseSizeLength;                               // ケースサイズ（縦）
    this.caseSizeWidth = data.CaseSizeWidth;                                 // ケースサイズ（横）
    this.caseSizeHeight = data.CaseSizeHeight;                               // ケースサイズ（高）
    this.caseWeight = data.CaseWeight;                                       // ケース重量
    this.caseContainNum = data.CaseContainNum;                               // ケース入数
    this.caseJanCode = data.CaseJanCode;                                     // ケースＪＡＮコード
    this.factoryAddress = data.FactoryAddress;                               // 工場住所
    this.factoryAddressCount = 0;                                               // 工場住所設定カウンタ

    // ボタンの活性制御
    // 承認状態のチェック
    if (this.admitStatus === '0' || this.admitStatus === '1') {                 // 0:eBASE取込後、1:仮登録の場合

      // 商品形態タブのラジオボタン活性制御
      // ピースサイズ情報設定チェック
      enabledCheckResult
        = this.kymw1105Component.checkFormSize(this.pieceSizeLength,            // ピースサイズ（縦）
          this.pieceSizeWidth,                                                  // ピースサイズ（横）
          this.pieceSizeHeight,                                                 // ピースサイズ（高）
          this.pieceWeight);                                                    // ピース重量

      // 判定結果を設定
      if (enabledCheckResult) {
        // チェック結果true（活性化）
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Piece, true);
      } else {
        // チェック結果false（非活性）
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Piece, false);
      }

      // パックサイズ情報設定チェック
      enabledCheckResult
        = this.kymw1105Component.checkFormSize(this.packSizeLength,             // パックサイズ（縦）
          this.packSizeWidth,                                                   // パックサイズ（横）
          this.packSizeHeight,                                                  // パックサイズ（高）
          this.packWeight);                                                     // パック重量

      // 判定結果を設定
      if (enabledCheckResult) {
        // チェック結果true（活性化）
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Pack, true);
      } else {
        // チェック結果false（非活性）
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Pack, false);
      }

      // ボールサイズ情報設定チェック
      enabledCheckResult
        = this.kymw1105Component.checkFormSize(this.bowlSizeLength,             // ボールサイズ（縦）
          this.bowlSizeWidth,                                                   // ボールサイズ（横）
          this.bowlSizeHeight,                                                  // ボールサイズ（高）
          this.bowlWeight);                                                     // ボール重量

      // 判定結果を設定
      if (enabledCheckResult) {
        // チェック結果true（活性化）
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Bowl, true);
      } else {
        // チェック結果false（非活性）
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Bowl, false);
      }

      // ケースサイズ情報設定チェック
      enabledCheckResult
        = this.kymw1105Component.checkFormSize(this.caseSizeLength,             // ケースサイズ（縦）
          this.caseSizeWidth,                                                   // ケースサイズ（横）
          this.caseSizeHeight,                                                  // ケースサイズ（高）
          this.caseWeight);                                                     // ケース重量

      // 判定結果を設定
      if (enabledCheckResult) {
        // チェック結果true（活性化）
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Case, true);
      } else {
        // チェック結果false（非活性）
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Case, false);
      }

      // 閲覧ﾕｰｻﾞは非活性にする
      this.kymw1105Component.plessEnabled(this.kymw1105Component.btn_Form_Set, true);

      // ＪＡＮコードタブのラジオボタン活性制御
      // ピースＪＡＮコードの存在チェック
      if (PlessViewUtilsSub.isEmpty(this.pieceJanCode)) {                       // 存在しない場合

        // 非活性を設定
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Piece, false);
      } else {                                                                  // 存在する場合

        // 活性を設定
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Piece, true);
      }

      // パックＪＡＮコードの存在チェック
      if (PlessViewUtilsSub.isEmpty(this.packJanCode)) {                        // 存在しない場合

        // 非活性を設定
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Pack, false);
      } else {                                                                  // 存在する場合

        // 活性を設定
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Pack, true);
      }

      // ボールＪＡＮコードの存在チェック
      if (PlessViewUtilsSub.isEmpty(this.bowlJanCode)) {                        // 存在しない場合

        // 非活性を設定
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Bowl, false);
      } else {                                                                  // 存在する場合

        // 活性を設定
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Bowl, true);
      }

      // ケースＪＡＮコードの存在チェック
      if (PlessViewUtilsSub.isEmpty(this.caseJanCode)) {                        // 存在しない場合

        // 非活性を設定
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Case, false);
      } else {                                                                  // 存在する場合

        // 活性を設定
        // 閲覧ﾕｰｻﾞは非活性にする
        this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Case, true);
      }
      // 閲覧ﾕｰｻﾞは非活性にする
      this.kymw1105Component.plessEnabled(this.kymw1105Component.btn_JanCode_Set, true);

      // 工場住所タブの設定ボタン活性制御
      this.kymw1105Component.setFactoryAddressEnabled();                        // 工場住所設定ボタン活性設定処理
    } else {                                                                    // 0:eBASE取込後、1:仮登録以外の場合

      // ボタンを非活性にする

      // 商品形態ラジオボタン
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Piece, false);
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Pack, false);
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Bowl, false);
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_Form_Case, false);

      // ＪＡＮコードラジオボタン
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Piece, false);
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Pack, false);
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Bowl, false);
      this.kymw1105Component.plessEnabled(this.kymw1105Component.rdb_JanCode_Case, false);

      // 設定ボタン
      this.kymw1105Component.plessEnabled(this.kymw1105Component.btn_Form_Set, false);      // 商品形態設定ボタン
      this.kymw1105Component.plessEnabled(this.kymw1105Component.btn_JanCode_Set, false);   // ＪＡＮコード設定ボタン
      this.kymw1105Component.plessEnabled(this.kymw1105Component.btn_TextInfo_Set, false);  // 工場住所設定ボタン
    }
  }

}
